// src/components/Header.jsx
import React from 'react';

const Header = (className) => {
    return (
    <section id="header" className={`wrapper ${className.className}`}>

        <div id="logo">
            <div className="site-name"><a href="/">ITS Projects Pty Ltd</a></div>
            <p>Quality | Affordable | Reliable</p>
        </div>

    
        <nav id="nav">
            <ul>
                <li className="current"><a href="/">ITS Projects Pty Ltd</a></li>
                <li><a href="/about-us">About Us</a></li>
                <li><a href="/contact-us">Contact Us</a></li>
                <li><a href="/products">Products</a></li>
                <li><a href="/inspiration">Inspiration</a></li>
                
            </ul>
        </nav>

</section>

);
};

export default Header;
